export default __webpack_public_path__ + "static/media/rotbehBehdasht.f6232447.jpeg";